import { render, staticRenderFns } from "./BalanceWallet.vue?vue&type=template&id=5dec052d&scoped=true"
import script from "./BalanceWallet.vue?vue&type=script&lang=js"
export * from "./BalanceWallet.vue?vue&type=script&lang=js"
import style0 from "./BalanceWallet.vue?vue&type=style&index=0&id=5dec052d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dec052d",
  null
  
)

export default component.exports